import React from 'react';

import { FlexLayout } from '@zapier/common-components';
import CommonDismiss from 'app/developer-v3/components/Dismiss';

import { JobsCta } from './JobsCta';

type Props = {
  profileId: number;
  onDismiss: () => void;
};

export const DismissibleJobsCta = ({ onDismiss, profileId }: Props) => (
  <FlexLayout justify="flex-end">
    <JobsCta />

    {!!profileId && (
      <CommonDismiss
        aria-label="Close Top Bar"
        iconSize={10}
        onDismiss={onDismiss}
      />
    )}
  </FlexLayout>
);
